import React from 'react';
import { Button } from '@printdeal/ui-library';
import { FormattedMessage } from 'react-intl';
import { Image } from '@unpic/react';
import { Experiment } from '@printdeal/feature-management/react';
import { Link } from 'gatsby';
import { dispatchDataLayerEntry } from '../../../helpers/dataLayerHelpers/productDataLayerHelper';
// @ts-expect-error
import image from './images/Tom-Freriks.png';

interface Props {
  text: React.ReactNode;
  source: 'homepage' | 'PDP-easy' | 'PDP-advanced';
}

const PersonalAssistance = ({ text, source }: Props) => {
  const handleClick = () => {
    dispatchDataLayerEntry('promote_order_guidance', 'click', { source });
  };

  return (
    <Experiment id="ninjas_exp1598_promote_order_guidance">
      <Experiment.Variant>
        <div>
          <div className="pd-relative pd-flex pd-flex-col pd-items-center pd-gap-5 pd-rounded-md pd-bg-dim-100 md:pd-flex-row md:pd-p-0">
            <Image className="-pd-mt-5 pd-block md:pd-self-end" width={100} height={100} src={image} />
            <div className="pd-flex pd-grow pd-flex-wrap pd-items-center pd-justify-center pd-gap-5">
              <span className="pd-font-semibold">
                {text}
              </span>
              <Button as={Link} to="https://www.drukwerkdeal.nl/nl/pages/printpartner" variant="secondary" onClick={handleClick}>
                <FormattedMessage id="general.personal.advice.buttonText" defaultMessage="Request" />
              </Button>
            </div>
          </div>
        </div>
      </Experiment.Variant>
    </Experiment>
  );
};

export default PersonalAssistance;
